import {FormBuilder, FormGroup} from '@angular/forms';
import {
  Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges
} from '@angular/core';

import {FilterPanel} from './model/filter-panel.model';
import {FilterValue} from './model/filter-value.model';
import {DealTypeEnum} from './model/deal-type.enum';
import {BreakpointObserver} from '@angular/cdk/layout';
import {SearchFilterService} from './search-filter.service';
import {PropertyFilterGroup} from './model/property-type-group.model';
import { getE } from 'src/app/core/helpers/object.helper';
import { ProductTypeEnum } from '../../models/product-type.enum';

@Component({
  selector: 'lps-search-filter',
  templateUrl: './search-filter.component.html',
  styleUrls: ['./search-filter.component.scss'],
})
export class SearchFilterComponent implements OnInit, OnChanges {

  @Input() value: FilterValue;
  @Input() theme?: string;
  @Input() showOperationType: boolean;
  @Output() valueChange: EventEmitter<FilterValue> = new EventEmitter<FilterValue>();

  form: FormGroup;
  errorsOnForm: any = [];
  isMobile: boolean;
  propertyFilters: PropertyFilterGroup[] = [];

  panels: FilterPanel[] = [
    {
      id: 'operation',
      active: false,
      name: 'Tipo de transação',
      disabled: false,
      groupingName: 'tipo-de-transacao'
    },
    {
      id: 'type',
      active: false,
      name: 'Tipo do imóvel',
      disabled: false,
      groupingName: 'tipo-do-imovel'
    },
    {
      id: 'characteristics',
      active: false,
      disabled: false,
      name: 'Características do imóvel',
      groupingName: 'caracteristicas-do-imovel'
    },
    {
      id: 'area',
      active: false,
      disabled: false,
      name: 'Área'
    },
    {
      id: 'value',
      active: false,
      disabled: false,
      name: 'Valor'
    },
    {
      id: 'moreFilters',
      active: false,
      disabled: false,
      name: 'Outros filtros',
      groupingName: 'outros-filtros'
    }
  ];

  constructor(
    private formBuilder: FormBuilder,
    public breakPoint: BreakpointObserver,
    private searchFilterService: SearchFilterService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.theme?.firstChange) {
     this.setTheme();
    }

    this.propertyFilters = this.searchFilterService.getPropertyTypes();
  }

  setTheme() {
    this.searchFilterService.theme = this.theme;
  }

  ngOnInit() {

    this.form = this.formBuilder.group({
      dealType: [getE(this.value, 'dealType', DealTypeEnum.Sale)],
      productTypes: [getE(this.value, 'productTypes', [ProductTypeEnum.RealEstateParent, ProductTypeEnum.RealState])],
      area: [getE(this.value, 'area', {min: '', max: ''})],
      characteristics: [getE(this.value, 'characteristics', [])],
      moreFilters: [getE(this.value, 'moreFilters', [])],
      propertyTypes: [getE(this.value, 'propertyTypes', [])],
      value: [getE(this.value, 'value', {min: '', max: ''})],
    });

    this.breakPoint.observe(['(max-width: 768px)'])
      .subscribe((state) => {
        this.isMobile = state.matches;
      });
  }

  setFormValue(key: string, value: any) {
    if (value.error) {
      this.errorsOnForm.push(key);
    } else {
      const control = this.form.get(key);
      this.errorsOnForm = this.errorsOnForm.filter(error => error !== key);
      if (control) {
        control.setValue(value);
      }
    }
  }

  cleanValue(key: string, value: any) {
    this.setFormValue(key, value);
  }

  emit() {
    const value = this.form.getRawValue();
    this.valueChange.emit(value);
  }

  setDealType(dealType: DealTypeEnum) {
    if (dealType === DealTypeEnum.Rent) {
      this.form.controls.productTypes.setValue([]);
    }
    this.setFormValue('dealType', dealType);
  }

}
